module.exports = __webpack_public_path__ + "img/placeholder.053134c.png";